import React from 'react';
import time from 'utils/time';
import ContentTypeBadge from 'components/Dashboard/components/ContentTypeBadge';
import { ListItemContainer, ListItemContent } from 'components/Dashboard/ItemController/ListItemLayout';

const LegislationUpdateItem = ({ update }) => {
  if (!update) return null;
  const { category, title, stage, dateTime, sourceUrl } = update;

  const content = (
    <ListItemContent className='px-4 py-3'>
      {!!category && (
        <div className='mt-1 specific-bottom-margin-12 flex-grow-1 text-light-blue blue-icon content-type-badge'>
          <ContentTypeBadge objectType='Legislation' name={category} />
        </div>
      )}
      {!!title && <h4 className='mb-2 content-item-title'>{title}</h4>}
      <p className='heading-date mb-0'>
        {!!stage && (
          <>
            <span>{stage}</span>
            <span className='dot'></span>
          </>
        )}
        {!!dateTime && (
          <span className='date'>{time(dateTime, { utc: true, skipTimezone: true }).formatLongDate(false)}</span>
        )}
      </p>
    </ListItemContent>
  );

  return (
    <ListItemContainer className='my-2 content-item' as='li'>
      {sourceUrl ? (
        <a href={sourceUrl} target='_blank' rel='noopener noreferrer' className='content-item-link'>
          {content}
        </a>
      ) : (
        content
      )}
    </ListItemContainer>
  );
};

export default LegislationUpdateItem;
